<template>
<div class="bottm-btn-box" :class="{ isH5: (isH5 || !isWeiXin) && !isHarmonyosIdentifying}"><!-- , 'show-new-route-box': showNewRouteBox -->
    <!-- <div class="search-content-box">
        <div class="btn coupon-btn" @click="gotoGroupCoupon">附近优惠</div>
        <div class="btn route-btn" @click="showRouteBoxFun">推荐线路</div>
        <div class="btn search-btn" @click="showSearchBoxFun">快速搜索</div>
    </div> -->
    <template v-if="isWeiXin">
        <div class="new-search-content-box" v-if="isNew">
            <div class="btn route-btn" @click="showRouteBoxFun">
                <img src="../../assets/new-style/hear@2x.png" alt="">
                <span>{{ linesArr.length > 0 ? (isHarmonyosIdentifying ? $t('main.play_route') : $t('main.recommended_routes')) : $t('main.go_here') }}</span>
            </div>
            <div class="btn search-btn" @click="walking">
                <img src="../../assets/new-style/route@2x.png" alt="">
                <span>{{ $t('main.listen_on_go') }}</span>
            </div>
            <div class="btn spot-btn" @click="showSpotFun">
                <img src="../../assets/new-style/facilities@2x.png" alt="">
                <span>{{ $t('main["景点设施"]') }}</span>
            </div>
        </div>
        <div class="search-content-box" v-else>
            <!-- <div class="btn coupon-btn" :class="{'coupon-scenic': scenic == 1}" @click="switchList">我的位置</div>
            <div class="btn route-btn" :class="{'route-scenic': scenic == 1}" @click="showRouteBoxFun">{{ linesArr.length > 0 ? (isHarmonyosIdentifying ? '游玩路线' : '推荐线路') : '去这里' }}</div>
            <div class="btn search-btn" :class="{'search-scenic': scenic == 1}" @click="walking">边走边听</div> -->
            <div class="btn coupon-btn" :class="{'coupon-scenic': scenic == 1}" @click="switchList">{{ $t('main.my_position') }}</div>
            <div class="btn route-btn" :class="{'route-scenic': scenic == 1}" @click="showRouteBoxFun">{{ linesArr.length > 0 ? (isHarmonyosIdentifying ? $t('main.play_route') : $t('main.recommended_routes')) : $t('main.go_here') }}</div>
            <div class="btn search-btn" :class="{'search-scenic': scenic == 1}" @click="walking">{{ $t('main.listen_on_go') }}</div>
        </div>
    </template>
    <div class="my-place" @click="switchList"></div>
    <!-- 弹框遮罩层 -->
    <div class="popup-mask-box"></div>
    <!-- 搜索列表弹框 -->
    <div class="search-list-box" :class="{show: showSearchBox, 'search-list-box-scenic': scenic == 1}" :style="{bottom: isNew ? '' : (navHide ? '0' : '1rem')}">
        <div class="top-search-input">
            <form @submit.prevent="formSubmit">
                <img class="input-icon" v-if="isNew" src="../../assets/new-style/icon_search@2x.png" alt="">
                <img class="input-icon" v-else src="../../assets/search_icon_1.png" alt="">
                <input type="search" name="keyword" :placeholder="$t('main.spots_search_placeholder')" v-model="keyword" @keyup="formSubmit" @blur="pageReset">
                <div class="clean-text" @click='cleanText' v-if="keyword != ''"></div>
            </form>
            <div class="close-btn" @click="showSearchBoxFun"></div>
        </div>
        <div class="list-box">
            <ul>
                <li v-for="(item, idx) in list" :key="idx" @click="showSpot(idx)">
                    <div class="title" :class='{"group-coupon": item.flag_c == 1}'>{{item.title ? item.title: ''}}
                        <!-- <div class="jl-num">{{item.distance/1000}}km</div> -->
                        <div class="jl-num">{{item.distance}}</div>
                    </div>
                    <div class="subtitle">
                        <span class="subtitle-content">{{item.subtitle}}&nbsp;</span>
                        <div class="detail-btn" v-if="item.id && isWeiXin" @click.stop='gotoDetail(idx)'> <!--  v-if="(item.ctype == 1 || item.ctype == 2 || item.ctype == 3) && item.cstatus == 2" -->
                            <div class="text">{{ $t('main.spots_detail') }}</div>
                        </div>
                    </div>
                </li>
                <li class="point-list">{{pointText}}</li>
            </ul>
        </div>
    </div>
    <!-- 新线路弹框 -->
    <div class="route-box" :class="{show: (showLinesList && !isNew), bottomHeight: isIphoneX, navHide}">
        <div class="route-labels">
            <div v-for="item in lineLables" :key="item.id" :class="['route-label', item.id == curLabel.id ? 'checked' : '']" @click="checkedLabel(item)">{{ $t(item.title) }}</div>
        </div>
        <div class="item" v-for="(item, idx) in linesArr" :key="idx" @click.stop="showLineOnMap(idx)">
            <div class="left">
                <p class="title" :class="{'selected':item.id==linesArr[dotid].id && showRouteDetail}">{{item.title}}<span v-if="item.push == 2 && !isHarmonyosIdentifying" class="corner-mark">{{ $t('main.recommend') }}</span></p>
                <p class="detail">
                    <span>{{item.times}}{{ $t('main.hours') }}</span>
                    <template v-if="$i18n.locale == 'en'">
                        {{item.total}} tourist attractions
                    </template>
                    <template v-else>
                        景点数{{item.total}}个
                    </template>
                </p>
            </div>
            <button @click.stop="hideLineOnMap" v-if="showHideLineBtn && item.id==curSelectedLins.id">{{ $t('main.hide') }}</button>
            <button @click.stop="showLineOnMap(idx)" :class="{'btn-scenic':scenic==1}" v-else>{{ $t('main.check') }}</button>
        </div>

    </div>
    <div class="mask" :class="{show: (showLinesList && !isNew)}" @click="showLinesList=false" @touchmove='divTouchMove($event)'></div>
    <!-- 点击显示线路后的详情弹框 -->
    <div class="route-detail-box" :class="{active:( showRouteDetail && !isNew ),'hide':( hideRouteDetail && !isNew ),'isIphoneX': isIphoneX}">
        <div class="showBox" v-if="hideRouteDetail" @click="hideRouteDetail=false"></div>
        <div class="hideBox" @click="hideRouteDetail=true"></div>
        <div class="close-btn" @click="closeRouteDetail"></div>
        <!-- 小点点 -->
        <div class="dot-box" v-if="linesArr.length>1">
            <p class="dot" v-for="(dotItem,dotIndex) in linesArr" :key="dotIndex" :class="{'active':dotid==dotIndex, 'active-scenic':dotid==dotIndex&&scenic==1}"></p>
        </div>
        <div class="item" v-if="!hideRouteDetail" 
            @mousedown="onmousedown" @mousemove="onmousemove" @mouseup="onmouseup"
            @touchstart="onmousedown" @touchend="onmouseup">
            <!-- 上面部分 -->
            <!-- 不阻止touchend传播是因为为了让用户在上划显示介绍的时候有更多的可触发空间 -->
            <div class="top" @touchstart.stop="touchStart($event)" @touchend="touchEnd($event)" @touchmove.stop='divTouchMove($event)'>
                <!-- 线路标题 -->
                <p class="title">{{curSelectedLins.title}}</p>
                <!-- 线路副标题 -->
                <p class="subtitle">{{curSelectedLins.total}}{{ $t('main["个景点"]') }} / {{curSelectedLins.distance}}{{ $t('main["公里"]') }} / {{curSelectedLins.times}}{{ $t('main["小时"]') }}</p>
            </div>
            <!-- 下面部分 -->
            <div class="bottom">
                <div class="box" v-for="(item,idx) in curSelectedLins.data" :key="idx">
                    <div class="content" @click="showInfoWindow(idx, curSelectedLins.id)">
                        <!-- 序号 -->
                        <p class="index" :class="{active:idx==routePlaceSelectId,'index-scenic':scenic==1,'active-sc':idx==routePlaceSelectId&&scenic==1}">{{idx+1}}</p>
                        <!-- 地点名称 -->
                        <p class="title">{{item.title}}</p>
                    </div>
                    <!-- 箭头 -->
                    <div class="arrow" :class="{'arrow-scenic':scenic==1}" v-if="idx < curSelectedLins.data.length-1">
                        <span class="nxmode-text" v-if="item.nxmode">{{ $t(`main["${ item.nxmode.text }"]`) }}</span>
                        <span class="nxmode-nxdistance" v-if="item.nxdistance">{{item.nxdistance}}km</span>
                    </div>
                </div>
            </div>

            <div class="explain" v-if="curSelectedLins.line_introduce">
                <div class="explain-top" @click="showExplain = true" v-if="!showExplain">
                    <div class="icon" :class="{icon1: scenic!=1 || ['lanyuewan', 'xiliwan'].includes($route.query.scenicType)}"></div>
                    <span class="txt">{{ $t('main["上划查看路线介绍"]') }}</span>
                </div>
                <!-- 组织事件传播 防止滑动查看内容时关闭介绍 不阻止mouseup、touchend鼠标松开事件 是为了让用户在下滑隐藏介绍内容的时候有更多的可以触发的地方 不会下滑到介绍内容就不能关闭介绍内容 -->
                <div class="explain-bottom" v-if="showExplain" 
                @mousedown.stop="" @mousemove.stop=""
                @touchstart.stop="" @touchmove.stop="">
                    <span class="explain-content" v-html="curSelectedLins.line_introduce"></span>
                </div>
            </div>
        </div>
    </div>

    <!-- 2024年4月15日改版推荐路线 -->
    <div class="new-route-box" v-if="showNewRouteBox">
        <div class="lines" v-show="showLinesList">
            <div class="title">{{ $t('main.recommended_routes') }}</div>
            <div class="labels">
                <div v-for="item in lineLables" :key="item.id" :class="['item', item.id == curLabel.id ? 'checked' : '']" @click="checkedLabel(item)">{{ $t(item.title) }}</div>
            </div>
            <!-- <div class="line-list">
                <div class="item" v-for="(item, idx) in linesArr" :key="idx" @click.stop="showLineOnMap(idx)">
                    <div class="tit">{{item.title}}</div>
                    <div class="tips">
                        <template v-if="$i18n.locale == 'en'">
                            {{item.total}} scenic spots
                        </template>
                        <template v-else>
                            景点数{{item.total}}个
                        </template> | {{item.times}}{{ $t('main.hours') }}
                    </div>
                </div>
            </div> -->
            <div class="line-list-swipe">
                <mt-swipe :auto="0" > 
                    <mt-swipe-item v-for="(item, index) in Math.ceil(linesArr.length / 2)" :key="item">
                        <div class="item" v-for="(item) in linesArr.slice(index * 2, index * 2 + 2)" :key="item.id" @click.stop="showLineOnMap(linesArr.indexOf(item))">
                            <div class="tit">{{item.title}}</div>
                            <div class="tips">
                                <template v-if="$i18n.locale == 'en'">
                                    {{item.total}} scenic spots
                                </template>
                                <template v-else>
                                    景点数{{item.total}}个
                                </template> | {{item.times}}{{ $t('main.hours') }}
                            </div>
                        </div>
                    </mt-swipe-item>
                </mt-swipe>
            </div>
        </div>
        <div class="route-detail" v-show="showRouteDetail">
            <div class="route-detail-top">
                <div class="header">
                    <div class="back" @click="closeRouteDetail();showLinesList=true">
                        <img class="icon" src="./../../assets/showBox_left_icon.png" alt="">
                        <span>{{ $t('main["返回"]') }}</span>
                    </div>
                    <div class="check-map" @click="showRouteDetail = false; showLineTypeSwitch = true">
                        <span>{{ $t('main["查看地图"]') }}</span>
                        <img class="icon" src="./../../assets/showBox_left_icon.png" alt="">
                        <img class="icon" src="./../../assets/showBox_left_icon.png" alt="">
                    </div>
                </div>
                <div class="line-list">
                    <div class="item" :class="{active: item.id == curSelectedLins.id}" v-for="(item, idx) in linesArr" :key="idx" @click.stop="showLineOnMap(idx)">
                        <div class="tit">{{item.title}}</div>
                        <div class="tips">
                            <template v-if="$i18n.locale == 'en'">
                                {{item.total}} scenic spots
                            </template>
                            <template v-else>
                                景点数{{item.total}}个
                            </template> | {{item.times}}{{ $t('main.hours') }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="explain" v-if="curSelectedLins.line_introduce">
                <div class="explain-top">
                    <div class="tit">{{ $t('main["路线介绍"]') }}</div>
                    <div class="line"></div>
                    <div class="btn" @click="showExplain = !showExplain">{{ showExplain ? $t('main["收起"]') : $t('main["展开查看"]') }}</div>
                </div>
                <div class="explain-content" v-if="showExplain">
                    <span v-html="curSelectedLins.line_introduce"></span>
                </div>
            </div>
            <div class="route-detail-content">
                <div class="item" v-for="(item,idx) in curSelectedLins.data" :key="idx" @click="showInfoWindow(idx, curSelectedLins.id);showRouteDetail=false;showLinesList=false;hideLineOnMap()">
                    <div class="num">{{ idx + 1 }}</div>
                    <div class="line"></div>
                    <img class="img" :src="item.thumb" alt="">
                    <div class="info">
                        <div class="tit">{{ item.title }}</div>
                        <div class="distance">
                            <template v-if="$i18n.locale == 'en'">{{item.distance}} away from you</template>
                            <template v-else>距离您{{item.distance}}</template>
                        </div>
                    </div>
                    <div class="go-here" @click="goHere(item)" v-if="isWeiXin">
                        <img class="icon" src="../../assets/new-style/icon_GoHere_s@2x.png" alt="">
                        <span>{{ $t('main.go_here') }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="line-type-switch" v-show="showLineTypeSwitch">
            <div class="back" @click="showLineTypeSwitch=false; showRouteDetail=true">
                <img class="icon" src="./../../assets/showBox_left_icon.png" alt="">
                <span>{{ $t('main["路线详情"]') }}</span>
            </div>
            <div class="btns">
                <div class="btn" @click="showLineOnMap(linesArr.indexOf(curSelectedLins))">
                    <div class="icon" :class="{active: showHideLineBtn}"></div>
                    <span>路线</span>
                </div>
                <div class="btn" @click="hideLineOnMap">
                    <div class="icon" :class="{active: !showHideLineBtn}"></div>
                    <span>景点</span>
                </div>
            </div>
        </div>
    </div>

    <!-- 语言弹框 -->
    <mt-actionsheet :actions="audiolist" v-model="showAudioSelectBox"></mt-actionsheet>
</div>
</template>

<script>
import Apis from '../../config/apis'
import _ from '../../config/util'
import {
    Toast, Swipe , SwipeItem
} from 'mint-ui'

let timer = null

let _this = null
window.callFuncGetLocation = (lat, lng, name) => {
    _this.callFuncGetLocation(lat, lng, name)
}

export default {
    name: 'Search',
    components: {
        // Swipe,
        // SwipeItem
    },
    props: {
        sid: {
            type: String
        },
        url: {
            type: String
        },
        showRoute: {
            type: String
        },
        isH5: {
            type: Boolean
        },
        navHide: {
            type: Boolean
        },
        lineLables: {
            type: Array
        }
    },
    data() {
        return {
            showSearchBox: false, // 是否显示搜索框
            pointText: '',// '途礼游技术支持', // 提示文字
            keyword: '', // 搜索关键字
            list: [], // 搜索结果列表
            oldMarkers: [], // 地图上已存在的marker点
            map: {}, // 地图对象
            playStatus: false, // 播放状态
            markers: [], // 地图新点
            showAudioSelectBox: false, // 是否显示播放音乐弹框
            audiolist: [], // 当前语音列表
            curScenicElementNode: null, // 当前点击的音频播放按钮节点
            showLinesList: false, // 是否显示线路列表
            linesArr: [], // 线路列表
            curSelectedLins: '', // 当前选择的线路
            oldSelectedLins: '', // 上一次选择的线路
            polyline: {}, // 折线实体
            polyline2: {}, // 虚线实体
            curShowLine: '', // 当前显示的线路数据
            showHideLineBtn: false, // 线路是否显示
            linesMarkers: [], // 线路中的marker点对象集合
            dotid: 0, //轮播小点的id
            touchX:0, //滑动时X坐标
            showRouteDetail:false,  //是否显示线路详情弹框
            hideRouteDetail:false,  //暂时隐藏线路详情弹框到右边
            showLineTypeSwitch: false, // 是否显示路线类型切换（切换成路线/点显示状态
            routePlaceSelectId:null, // 当前线路选中的地点的下标
            walkingOpen: false,
            interval: null,
            longitude: '',
            latitude: '',
            marker: [], // 轨迹点
            scenic: 0,
            isFirst:true,
            lastNearScenicSpotId:'', // 上一个开启边走边听后靠近20米范围内的景点id
            cacheKey:'', //用于接收在小程序储存的附近蓝牙数据
            isBluetooth: false, // 是否正在蓝牙方式运行边走边听
            storedAudio: '', // 音频播放过程中储存的搜索到的最近的音频
            // isNotWeiXin: false,
            curLabel: { // 当前选中的路线标签
                id: ''
            },
            showExplain: false,
            explainData: {
                startTime: 0,
                // start_slide_x: 0,
                startY: 0,
                lastY: 0,
            }
        }
    },
    // 获取全局数据
    computed: {
        curClassify() {
            return this.$store.state.curClassify
        },
        userLocation() {
            return this.$store.state.userLocation
        },
        // 获取所有景点信息
        curScenicList() {
            return this.$store.state.curScenicList
        },
        // 获取当前选中的点信息
        curScenicItem() {
            return this.$store.state.curScenicItem
        },
        // 是否微信环境
        isWeiXin() {
            return this.$store.state.isWeiXin
        },
        // 获取当前显示状态
        showDetailPop() {
            return this.$store.state.showDetailPop
        },
        isIphoneX() {
            return !(this.$route.query.isIphoneX == 'false')
        },
        // 景区信息
        scenicInfo() {
            return this.$store.state.scenicInfo
        },
        isNotWeiXin(){
            return (window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) != 'micromessenger') && (window.navigator.userAgent.toLowerCase().match(/aweme/i) != 'aweme')
        },
        isHarmonyosIdentifying() {
            return this.$store.state.isHarmonyosIdentifying
        },
        isNew() {
            return this.$store.state.isNew
        },
        showNewRouteBox() {
            return (this.showLinesList || this.showRouteDetail || this.showLineTypeSwitch) && this.isNew
        }
    },
    // 监听数据变化
    watch: {
        curClassify() {
            // 更新显示线路按钮显示状态
            this.showHideLineBtn = false
            // 修改显示线的数据
            this.curShowLine = ''
            //线路详情弹框关闭
            this.showRouteDetail=false
            this.hideRouteDetail=false
            //搜索列表框隐藏
            this.showSearchBox=false
        },
        userLocation() {
            // 获取路线
            this.getScenicLins()
        },
        // 获取当前显示状态
        showDetailPop() {
            if(!this.showDetailPop&&this.showRouteDetail){
                this.hideRouteDetail=false
            }
            // 2022/2/28增加 蓝牙模式边走边听的过程中关闭了景点详情 且没有正在播放的音频 
            let playEl = document.getElementsByClassName('go-detail')[0]
            if(!this.showDetailPop && this.isBluetooth && !(playEl && playEl.classList.contains('isPlay'))) {
                // 立即搜索最近的景点
                this.playNearScenicSpot(-1, -1)
                // 关闭之前正在搜索附近景点的计时器
                if(this.intervalKey) {
                    clearInterval(this.intervalKey)
                    this.intervalKey = ''
                }
                // 每隔五秒钟获取一次最近的景点并播放录音
                // 2022/3/7 改为3秒一次
                this.intervalKey = setInterval(()=>{
                    this.playNearScenicSpot(-1, -1)
                }, 3000)
            }
            if(this.showDetailPop){
                 //搜索列表框隐藏
                this.showSearchBox=false
            }
        },
        showLinesList(newData) {
            let el = document.getElementsByClassName('route-box')[0]
            if(newData && el && !el.style.height) {
                el.style.height = `${el.clientHeight}px`
            }
            this.showExplain = false
        },
        curSelectedLins() {
            this.showExplain = false
        }
    },
    mounted() {
        // this.scenic = this.$route.query.scenic
        this.scenic = 1
        this.cacheKey = this.$route.query.cacheKey

        _this = this
        // 显示详情
        window.sshowDetail = () => {
            // 显示详情
            this.$store.commit('setDetailPopupStatus', true)
            if(this.showRouteDetail){this.hideRouteDetail=true}
            this.showSearchBox=false
        }
        // 查看详情按钮
        window.lookDetail=()=>{this.lookDetail()}
        // 去这里按钮
        window.goHere=()=>{this.goHere()}
        // 关闭推荐路线
        window.hideRouteDetailFun = () => {
            this.hideRouteDetail=false
            this.showRouteDetail = false
        }
        // 关闭搜索弹窗
        window.hideSearchBoxFun = () => {
            this.showSearchBox = false
        }

        // 播放音频
        window.splayAudio = (e, url) => {
            console.log('***sear',e)
            const audio = document.getElementById('audio-dom')
            if (url.length == 1) {
                url[0]['el'] = e.firstChild.nextElementSibling
                this.playAudio(url[0])
            } else {
                if (this.playStatus) {
                    audio.pause()
                    this.playStatus = false
                    e.firstChild.nextElementSibling.style.display = 'none'
                } else {
                    // 显示详情
                    this.$store.commit('setDetailPopupStatus', false)
                    const audioShowList = []
                    // 处理音频列表数据
                    url.forEach(el => {
                        audioShowList.push({
                            name: el.title,
                            method: this.playAudio,
                            el: e.firstChild.nextElementSibling,
                            url: el.url
                        })
                    })
                    this.audiolist = audioShowList
                    // 存储当前点击的marker上的音频按钮节点
                    this.curScenicElementNode = e
                    this.showAudioSelectBox = true
                }
            }
        }
        // 处理iPhone在没有手动点击播放语音之前无法通过代码触发语音播放问题
        let testFun = ()=> {
            document.getElementById('audio-dom').play()
            document.removeEventListener('click', testFun)
        }
        document.addEventListener('click', testFun)

        // this.isNotWeiXin = (window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) != 'micromessenger') || (window.navigator.userAgent.toLowerCase().match(/aweme/i) == 'aweme')

        this.$bus.$on('showSearchBoxFun', this.showSearchBoxFun)

        window._this1 = this
    },
    destroyed() {
        this.closeGetBluetooth()
    },
    methods: {
        //把组件my-location-btn.vue的搬过来到这里了
        switchList() {
            // 如果点击定位时轨迹正在显示，则关闭轨迹
            if(this.walkingOpen){
                this.walkingOpen=false
                this.closeWalking()
            }

            this.map = this.$store.state.mapObj
            const userLocationMarker = this.$store.state.userLocationMarker
            this.getCurrentPosition().then(res => {
                const amapLngLat = new AMap.LngLat(this.longitude, this.latitude)
                if (userLocationMarker == '') {
                    // 自定义标记点
                    const content =
                        '<div class="custor-marker"><div class="user-photo"></div></div>'
                    const marker = new AMap.Marker({
                        content: content,
                        position: [this.longitude, this.latitude],
                        offset: new AMap.Pixel(-40, -80),
                        map: this.map
                    })
                    this.$store.commit('setUserLocationMarker', marker)
                } else {
                    userLocationMarker.setPosition(amapLngLat)
                    userLocationMarker.setMap(this.map)
                }
                // 将地图移动到用户的位置
                this.map.panTo(amapLngLat)
            })
            
            
            // if (this.isWeiXin) {
            //     this.map = this.$store.state.mapObj
            //     const userLocationMarker = this.$store.state.userLocationMarker
            //     // 获取当前地图的限制区域
            //     const limtBounds = this.map.getLimitBounds()
            //     // 获取用户当前位置
            //     _.geolocation().then(res => {
            //         const amapLngLat = new AMap.LngLat(res.longitude, res.latitude)
            //         if (limtBounds) {
            //             // 判断是否在景区范围内
            //             if (limtBounds.contains(amapLngLat)) {
            //                 console.log('手动定位', userLocationMarker)
            //                 if (userLocationMarker == '') {
            //                     // 自定义标记点
            //                     const content =
            //                         '<div class="custor-marker"><div class="user-photo"></div></div>'
            //                     const marker = new AMap.Marker({
            //                         content: content,
            //                         position: [res.longitude, res.latitude],
            //                         offset: new AMap.Pixel(-40, -80),
            //                         map: this.map
            //                     })
            //                     this.$store.commit('setUserLocationMarker', marker)
            //                 } else {
            //                     userLocationMarker.setPosition(amapLngLat)
            //                     userLocationMarker.setMap(this.map)
            //                 }
            //                 // 将地图移动到用户的位置
            //                 this.map.panTo(amapLngLat)
            //             } else {
            //                 Toast('当前不在景区范围内！')
            //             }
            //         } else {
            //             if (userLocationMarker == '') {
            //                 // 自定义标记点
            //                 const content =
            //                     '<div class="custor-marker"><div class="user-photo"></div></div>'
            //                 const marker = new AMap.Marker({
            //                     content: content,
            //                     position: [res.longitude, res.latitude],
            //                     offset: new AMap.Pixel(-40, -80),
            //                     map: this.map
            //                 })
            //                 this.$store.commit('setUserLocationMarker', marker)
            //             } else {
            //                 userLocationMarker.setPosition(amapLngLat)
            //                 userLocationMarker.setMap(this.map)
            //             }
            //             // 将地图移动到用户的位置
            //             this.map.panTo(amapLngLat)
            //         }
            //     })
            // } else {
            //     this.map = this.$store.state.mapObj
            //     const userLocationMarker = this.$store.state.userLocationMarker
            //     this.getCurrentPosition()
            //     const amapLngLat = new AMap.LngLat(this.longitude, this.latitude)
            //         if (userLocationMarker == '') {
            //             // 自定义标记点
            //             const content =
            //                 '<div class="custor-marker"><div class="user-photo"></div></div>'
            //             const marker = new AMap.Marker({
            //                 content: content,
            //                 position: [this.longitude, this.latitude],
            //                 offset: new AMap.Pixel(-40, -80),
            //                 map: this.map
            //             })
            //             this.$store.commit('setUserLocationMarker', marker)
            //         } else {
            //             userLocationMarker.setPosition(amapLngLat)
            //             userLocationMarker.setMap(this.map)
            //         }
            //         // 将地图移动到用户的位置
            //         this.map.panTo(amapLngLat)
                
            // }
        },
        /**
         * 显示、隐藏轨迹
         * 2021/12/20 增加新功能 走到景点20米附近自动播放语音
         */
        walking() {
            this.walkingOpen = !this.walkingOpen

            // 广州
            // let obj1= new AMap.LngLat(113.2643600000,23.1290800000)
            // 罗定
            // let obj2= new AMap.LngLat(111.5700400000,22.7683000000)
            // console.log(obj1.distance(obj2))
            
            if (this.walkingOpen) {
                
                // Toast('开启轨迹显示')
                // Toast('走到景点附近自动播放语音讲解')
                Toast( this.$t('main["走到景点附近自动播放语音讲解"]') )

                // 通过位置定位
                // if(this.scenicInfo.location_type == 1 || this.scenic != 1) {
                    // 经纬度数组
                    let lnglatArr = []
                    // 上一次获取的经纬度
                    let lastLngLat
                    let flag

                    this.getCurrentPosition().then(res => {
                        lastLngLat={lng:this.longitude,lat:this.latitude}
                        console.log('首个lastLngLat:',lastLngLat)
                        lnglatArr.push({
                            lat: this.latitude,
                            lng: this.longitude,
                        })
                        this.playNearScenicSpot(lastLngLat.lat, lastLngLat.lng)
                        
                        this.drawWalkLine(lnglatArr) 
                    })

                    this.interval = setInterval(() => {
                        this.getCurrentPosition().then(res => {
                            flag={lng:this.longitude,lat:this.latitude}
                            console.log('flag:',flag)
                            // 增加新逻辑 在五秒后重新获取的经纬度距离上一个经纬度距离超过五米不显示
                            // 2021/12/22 改为20米
                            // 2022/01/14 时间改为10秒 取消距离限制
                            // 2022/01/19 距离改为50米
                            // 2022/02/15 距离改为30米
                            let distance = this.getDistance(this.latitude, this.longitude, lastLngLat.lat,lastLngLat.lng)
                            if((flag.lng!=lastLngLat.lng||flag.lat!=lastLngLat.lat) && distance < 30){
                            // if(flag.lng!=lastLngLat.lng||flag.lat!=lastLngLat.lat){
                                console.log('位置不相同，更新轨迹')
                                lastLngLat=flag
                                console.log('lastLngLat:',lastLngLat)
                                lnglatArr.push({
                                    lat: this.latitude,
                                    lng: this.longitude,
                                })
                                this.drawWalkLine(lnglatArr)

                                this.playNearScenicSpot(flag.lat, flag.lng)
                            }else{
                                console.log('位置相同，不更新轨迹')
                            }
                        })
                    }, 10000)
                // // 通过蓝牙定位 2020/2/21添加该功能
                // // 2022/3/7 从5秒改为3秒一次
                // } else {
                //     this.isBluetooth = true
                //     this.playNearScenicSpot(-1, -1)
                //     // 每隔五秒钟获取一次最近的景点并播放录音
                //     this.intervalKey = setInterval(()=>{
                //         this.playNearScenicSpot(-1, -1)
                //     }, 3000)
                // }

                // if(this.isWeiXin){
                
                //     // 获取用户当前位置
                //     _.geolocation().then(res => {
                //         lastLngLat={lng:res.longitude,lat:res.latitude}
                //         console.log('首个lastLngLat:',lastLngLat)
                //         lnglatArr.push({
                //             lat: res.latitude,
                //             lng: res.longitude
                //         })
                //         this.playNearScenicSpot(lastLngLat.lat, lastLngLat.lng)
                //         this.drawWalkLine(lnglatArr)    
                //     })
                    
                //     this.interval = setInterval(() => {
                        
                //         _.geolocation().then(res => {
                //             flag={lng:res.longitude,lat:res.latitude}
                //             console.log('flag:',flag)
                //             // 增加新逻辑 在五秒后重新获取的经纬度距离上一个经纬度距离超过五米不显示
                //             // 2021/12/22 改为20米
                //             let distance = this.getDistance(res.latitude, res.longitude, lastLngLat.lat,lastLngLat.lng)
                //             if((flag.lng!=lastLngLat.lng||flag.lat!=lastLngLat.lat) && distance < 20){
                //                 console.log('位置不相同，更新轨迹')
                //                 lastLngLat=flag
                //                 console.log('lastLngLat:',lastLngLat)
                //                 lnglatArr.push({
                //                     lat: res.latitude,
                //                     lng: res.longitude
                //                 })    
                //                 this.drawWalkLine(lnglatArr)

                //                 this.playNearScenicSpot(flag.lat, flag.lng)
                //             }else{
                //                 console.log('位置相同，不更新轨迹')
                //             }
                            
                //         }) 
                        
                //     }, 5000)
                // }else{
                //     this.getCurrentPosition()
                //     lastLngLat={lng:this.longitude,lat:this.latitude}
                //     console.log('首个lastLngLat:',lastLngLat)
                //     lnglatArr.push({
                //         lat: this.latitude,
                //         lng: this.longitude
                //     })
                //     this.playNearScenicSpot(lastLngLat.lat, lastLngLat.lng)
                    
                //     this.drawWalkLine(lnglatArr) 

                //     this.interval = setInterval(() => {
                //         this.getCurrentPosition()
                //         flag={lng:this.longitude,lat:this.latitude}
                //         console.log('flag:',flag)
                //         let distance = this.getDistance(this.latitude, this.longitude, lastLngLat.lat,lastLngLat.lng)
                //         if((flag.lng!=lastLngLat.lng||flag.lat!=lastLngLat.lat) && distance < 20){
                //             console.log('位置不相同，更新轨迹')
                //             lastLngLat=flag
                //             console.log('lastLngLat:',lastLngLat)
                //             lnglatArr.push({
                //                 lat: this.latitude,
                //                 lng: this.longitude
                //             })    
                //             this.drawWalkLine(lnglatArr)

                //             this.playNearScenicSpot(flag.lat, flag.lng)
                //         }else{
                //             console.log('位置相同，不更新轨迹')
                //         }
                        
                        
                //     }, 5000)
                // }
            } else {
                this.closeWalking()
            }
        },
        closeWalking(){
            // Toast('关闭轨迹显示')
            // Toast('关闭边走边听')
            Toast(this.$t('main["关闭边走边听"]'))
            clearInterval(this.interval)
            //清除marker点
            if(this.map.remove) this.map.remove(this.marker)
            //清除线路
            _.cleanMapOverlays(this)
            _.drawPoint(this) // 处理关闭轨迹后地图上景点内容消失问题

            this.closeGetBluetooth() // 关闭定时获取附近蓝牙数据的计时器
            // 清除上一个边走边听显示的景区
            this.lastNearScenicSpotId = ''
        },
        /**
         * 绘制线路
         */
        async drawWalkLine(data) {

            // 获取地图实例
            this.map = this.$store.state.mapObj
            // 如果当前有点击定位后留下的“我的位置”标记点，则清除掉
            const userLocationMarker = this.$store.state.userLocationMarker
                if(userLocationMarker!=''){
                    this.map.remove(userLocationMarker)
                }
            // 经纬度数据
            const lnglatArr = []
            let distance=0
            // 获取线路的经纬度
            data.map(el => {
                el.lng = el.lng
                el.lat = el.lat
                let lnglat = []
                lnglat.push(el.lng)
                lnglat.push(el.lat)
                lnglatArr.push(lnglat)
            })
            //根据每两个点的经纬度循环计算走过的距离
            if(lnglatArr.length>1){
                let obj1;let obj2
                for(let i=0;i<lnglatArr.length-1;i++){
                    obj1= new AMap.LngLat(lnglatArr[i][0],lnglatArr[i][1])
                    obj2= new AMap.LngLat(lnglatArr[i+1][0],lnglatArr[i+1][1])
                    distance+=obj1.distance(obj2)
                    // distance+=this.distanceByLnglat(lnglatArr[i][0],lnglatArr[i][1],lnglatArr[i+1][0],lnglatArr[i+1][1])
                }
            }
            
            // 折线配置项
            const polylineOptions = { // 
                strokeColor: '#FE656B', // 线条颜色
                path: lnglatArr, // 折线的节点坐标数组
                strokeOpacity: 0.00001,  // 透明度
                strokeStyle: 'solid', // 线样式，实线:solid，虚线:dashed
                lineJoin: 'round', // 折线拐点的绘制样式，默认值为'miter'尖角，其他可选值：'round'圆角、'bevel'斜角
                strokeWeight: 3 //线宽度
            }
            // 折线实例，画线
            const polyline = this.polyline = new AMap.Polyline(polylineOptions)
            polyline.setMap(this.map)

            // 移动到最新位置点
            this.map.panTo(new AMap.LngLat(lnglatArr[lnglatArr.length - 1].lng, lnglatArr[lnglatArr.length - 1].lat))
            
            // 清除上一次画的标记点
            this.map.remove(this.marker)
            // 画标注点
            lnglatArr.forEach((el, idx) => {
                // 起点
                // if(idx == 0 && lnglatArr.length>1){
                //      // 自定义起点的样式
                //     let contentStart = `<div class='walking-marker-icon-box'></div>`

                //     // 构造一个点标记对象
                //     let markerStart = new AMap.Marker({
                //         position: el,
                //         content: contentStart,
                //         offset: new AMap.Pixel(-2,-2),
                //     })
                //     markerStart.setMap(this.map)
                //     this.markers.push(markerStart)
                // }

                if (idx == lnglatArr.length - 1) {
                    // 自定义当前最新位置点的样式
                    //    let contentEnd = '<div class="custor-marker"><div class="user-photo"></div></div>'
                    //    let contentEnd = `<div class="walking-location-box"><div class="top">${Math.round((distance/1000)*1000)/1000}km</div><div class="location-icon"></div></div>`
                    let contentEnd = '<div class="walking-location-box"> <div class="location-icon"></div> </div>'

                    // 构造一个点标记对象
                   let markerEnd = new AMap.Marker({
                        position: el,
                        content: contentEnd,
                        offset: new AMap.Pixel(-44, -68),
                    })

                    markerEnd.setMap(this.map)
                    this.marker.push(markerEnd)
                    
                }
                
            })
        },
        getCurrentPosition() {
            return new Promise((reso,reje) => {
                if(this.isHarmonyosIdentifying) {
                    let name = `latlngData${ new Date().getTime() }`
                    console.info('调用鸿蒙os获取定位')
                    window.JsCallbackToLocation.call(name)
                    console.info('调用鸿蒙os获取定位-等待回调')
                    const inter = setInterval(() => {
                        console.info('调用鸿蒙os获取定位-计时器')
                        const data = this[name]
                        if(data) {
                            console.info('调用鸿蒙os获取定位-成功获取到数据-',data)
                            if(data.lat != 0) {
                                this.longitude = data.lng
                                this.latitude = data.lat
                            }
                            delete this[name]
                            reso()
                            clearInterval(inter)
                        }
                    }, 100)
                    return
                }

                let self = this
                AMap.plugin('AMap.Geolocation', function () {
                    var geolocation = new AMap.Geolocation({
                        // 是否使用高精度定位，默认：true
                        enableHighAccuracy: true,
                        // 设置定位超时时间，默认：无穷大
                        timeout: 10000,
                        // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
                        buttonOffset: new AMap.Pixel(10, 20),
                        // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                        zoomToAccuracy: true,
                        // 定位按钮的排放位置, RB表示右下
                        buttonPosition: 'RB'
                    })
                    geolocation.getCurrentPosition()
                    AMap.event.addListener(geolocation, 'complete', (e) => {
                        if(e.position.getLng() && e.position.getLat()) {
                            self.longitude = e.position.getLng()
                            self.latitude = e.position.getLat()
                            console.info('高德当前定位',self.latitude, self.longitude)
                            reso()
                        }
                    })
                    AMap.event.addListener(geolocation, 'error', (e) => {
                        console.log(e) // 定位失败做的事
                        switch (e.info) {
                            case 'PERMISSION_DENIED':
                                // Toast('浏览器阻止了定位操作！')
                                Toast(this.$t('main["浏览器阻止了定位操作！"]'))
                                reje()
                                break
                            case 'POSITION_UNAVAILBLE':
                                // Toast('无法获得当前位置！')
                                Toast(this.$t('main["无法获得当前位置！"]'))
                                reje()
                                break
                            case 'TIMEOUT':
                                // Toast('定位超时！')
                                Toast(this.$t('main["定位超时！"]'))
                                reje()
                                break
                            case 'FAILED':
                                console.log('谷歌浏览器禁止了非安全域的定位请求,正在启用百度定位')
                                self.addressDetail().then(res => {
                                    reso(res)
                                }).catch(err => {
                                    reje(err)
                                })
                        }

                    })
                })
            })
        },
        addressDetail() { //获取地理位置 
            return new Promise((reso, reje) => {
                var self = this
                //全局的this在方法中不能使用，需要重新定义一下
                var geolocation = new BMap.Geolocation()
                // 开启SDK辅助定位
                // geolocation.enableSDKLocation();
                //调用百度地图api 中的获取当前位置接口
                geolocation.getCurrentPosition(function (r) {
                    if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                        //获取当前位置经纬度
                        var myGeo = new BMap.Geocoder()
                        myGeo.getLocation(new BMap.Point(r.point.lng, r.point.lat), function (result) {
                            if (result) {
                                self.longitude = result.point.lng
                                self.latitude = result.point.lat
                                console.info('百度当前定位',self.latitude, self.longitude)
                                reso()
                            } else reje()
                        })
                    }
                })
            })
        },
        // 鸿蒙os获取当前定位后回调
        callFuncGetLocation(lat, lng, name) {
            console.info('调用鸿蒙os获取定位-java返回内容',lat,'-','-',lng,name)
            if(name) {
                // this.$set(this, name, {lat, lng})
                this[name] = {lat, lng}
            }
        },
        splayAudio(e, url) {
            const audio = document.getElementById('audio-dom')
            if (url.length == 1) {
                url[0]['el'] = e.currentTarget.firstChild
                this.playAudio(url[0])
            } else {
                if (this.playStatus) {
                    audio.pause()
                    this.playStatus = false
                    e.currentTarget.firstChild.style.display = 'none'
                } else {
                    // 显示详情
                    this.$store.commit('setDetailPopupStatus', false)
                    const audioShowList = []
                    // 处理音频列表数据
                    url.forEach(el => {
                        audioShowList.push({
                            name: el.title,
                            method: this.playAudio,
                            el: e.currentTarget.firstChild,
                            url: el.url
                        })
                    })
                    this.audiolist = audioShowList
                    // 存储当前点击的marker上的音频按钮节点
                    this.curScenicElementNode = e
                    this.showAudioSelectBox = true
                }
            }
        },
        // 播放音频
        playAudio(data) {
            const audio = document.getElementById('audio-dom')
            audio.src = data.url
            if (this.playStatus) {
                audio.pause()
                this.playStatus = false
                data.el.style.display = 'none'
            } else {
                audio.play()
                this.playStatus = true
                data.el.style.display = 'block'
            }
            audio.addEventListener('ended', () => {
                this.playStatus = false
                data.el.style.display = 'none'
            })
            // 隐藏弹框
            this.showAudioSelectBox = false
        },
        /**
         * 显示或隐藏搜索框
         */
        showSearchBoxFun() {
            // 设置点击搜索框里的选项为false（用于控制轨迹显示的）
            this.$store.commit('setIsShowSpot', false)
            // this.curClassify = this.$store.state.curClassify;
            const curScenicList = this.$store.state.curScenicList
            const temp = []
            curScenicList.forEach(el => {
                el['cstatus'] = this.curClassify.status
                el['ctype'] = this.curClassify.type
                temp.push(el)
            })
            this.list = temp
            this.showSearchBox = !this.showSearchBox
            this.map = this.$store.state.mapObj

            // 监听地图点击时事件
            this.map.on('click', () => {
                this.showSearchBox = false
                // 关闭详情弹框
                this.$store.commit('setDetailPopupStatus', false)
            })
            // 监听地图平移事件
            this.map.on('mapmove', () => {
                this.showSearchBox = false
                // 关闭详情弹框
                this.$store.commit('setDetailPopupStatus', false)
            })

            if(this.$route.query.scenicType === 'lishui') this.getSearchResult()
        },
        /**
         * 搜索表单提交
         */
        formSubmit() {
            clearTimeout(timer)
            timer = setTimeout(() => {
                this.getSearchResult()
            }, 500)
        },
        /**
         * 获取结果
         */
        // getSearchResult() {
        //     // 转高德为百度坐标
        //     const tramRes = _.bd_encrypt(this.userLocation[0], this.userLocation[1])
        //     const params = {
        //         keyword: this.keyword,
        //         sid: this.sid,
        //         lng: tramRes.lng,
        //         lat: tramRes.lat
        //     }
        //     this.axios.post(Apis.searchScenicSpots, params).then(res => {
        //         // 坐标转换
        //         const zzRes = []
        //         res.data != '' && res.data.forEach(el => {
        //             const result = _.bd_decrypt(el.lng, el.lat)
        //             // 将结果放入最终结果数组中
        //             el.lng = result.lng
        //             el.lat = result.lat
        //             zzRes.push(el)
        //         })
        //         this.list = zzRes
        //         if (zzRes.length == 0) {
        //             this.pointText = '没有找到相关数据哦！'
        //         } else {
        //             this.pointText = '途礼游技术支持'
        //         }
        //     })
        // },
        /**
         * 获取结果
         */
        getSearchResult() {
            // 转高德为百度坐标
            const tramRes = _.bd_encrypt(this.userLocation[0], this.userLocation[1])
            const params = {
                cid: this.curClassify.id,
                classify_id: this.curClassify.id,
                sid: this.sid,
                lng: tramRes.lng,
                lat: tramRes.lat,
                keywords: this.keyword,
                uid: this.uid || this.$route.query.uid
            }
            if(this.$route.query.scenicType === 'lishui') delete params.cid
            let spotsUrl = Apis.spots
            if(this.sid) spotsUrl = Apis.spots1
            this.axios.post(spotsUrl, params).then(res => {
                // 坐标转换
                const zzRes = []
                res.data != '' && res.data.forEach(el => {
                    const result = _.bd_decrypt(el.lng, el.lat)
                    // 将结果放入最终结果数组中
                    el.lng = result.lng
                    el.lat = result.lat
                    zzRes.push(el)
                })
                this.list = zzRes
                if (zzRes.length == 0) {
                    this.pointText = this.$t('main["没有找到相关数据哦！"]')
                } else {
                    // this.pointText = '途礼游技术支持'
                    this.pointText = ''
                }
            })
        },
        /**
         * 去详情
         */
        gotoDetail(idx) {
            // 景区通特有跳转 一机旅游需要此功能的时候需要做跳转处理
            const data = this.list[idx]
            if(!data.id) return // 高德查询出来的点位不给进入详情页
            let url = `pages/scenic/detail/index?id=${data.id}&category=${ data.category }${ this.sid ? '&isScenic=1' : '' }`
            // let url = `pages/scenic/info/index?id=${data.id}`
            if(this.isWeiXin) {
                window.uni.miniProgram.navigateTo({
                    url: `/${url}`,
                })
            } else {
                window.location.href = `${this.$scenicUrl}${url}`
            }
            // const data = this.list[idx]
            // if (this.isWeiXin) {
            //     // 景点详情
            //     if (data.ctype == 1) {
            //         window.uni.miniProgram.navigateTo({
            //             url: `/packages/city_service/scenic/detail/index?id=${data.id}`
            //         })
            //     }
            //     // 美食详情
            //     if (data.ctype == 2 || data.ctype == 3) {
            //         window.uni.miniProgram.navigateTo({
            //             url: `/packages/city_service/scenic/detail/index?id=${data.id}&type=${data.ctype == 2 ? 2 : 1}`
            //         })
            //     }
            // } else {
            //     // 景点详情
            //     if (data.ctype == 1) {
            //         window.location.href = `${this.$baseurl}packages/city_service/scenic/detail/index?id=${data.id}`
            //     }
            //     // 美食详情
            //     if (data.ctype == 2 || data.ctype == 3) {
            //         window.location.href = `${this.$baseurl}packages/city_service/scenic/detail/index?id=${data.id}&type=${data.ctype == 2 ? 2 : 1}`
            //     }
            // }
        },
        /**
         * 在地图上显示点
         */
        showSpot(idx) {
             // 设置点击了搜索框里的选项
            this.$store.commit('setIsShowSpot', true)
            // ----------------------------点击搜索列表里的景点时隐藏线路-----------------------
            // 清空上一次存储的marker点
            this.linesMarkers = []
            // 清空地图
            _.cleanMapOverlays(this)
            // 隐藏隐藏线路按钮
            this.showHideLineBtn = false
            // 隐藏线路详情弹框
            this.showRouteDetail=false
            this.hideRouteDetail=false
            // 修改显示线的数据
            this.curShowLine = ''
            // -------------------------------------------------------------------------------
            // 获取当前选中的点数据
            const data = this.list[idx]
            // 隐藏框
            this.showSearchBox = false
            // 自定义标记点
            const infoWindow = new AMap.InfoWindow({
                isCustom: true,
                offset: new AMap.Pixel(0, -50),
            })
             
            //  2022/9/21 不显示音频图标 显示逻辑为在audio-btn的class后加${data.audio != '' ? 'show': ''}
            let distance = isNaN(Number(data.distance)) ? data.distance : (data.distance/1000) + 'km'
            const content = `<div class="custor-marker-point">
                    <div class='top-info-box'>
                    
                        <div class='top-title'>
                            <div class='spot-name' onclick='sshowDetail(${data.id})'>${data.title}</div>
                            <div class='audio-btn ' onclick='splayAudio(this, ${JSON.stringify(data.audio)})'>
                                <div class="music-wrap">
                                    <ul class="music">
                                        <li class="m1"></li>
                                        <li class="m2"></li>
                                        <li class="m3"></li>
                                        <li class="m1"></li>
                                        <li class="m2"></li>
                                        <li class="m3"></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class='bottom'>
                        <img src='${data.thumb || (!data.id && this.curClassify.icon)}' onclick='sshowDetail(${data.id})' />
                        <div class='info-box'>
                            ${!this.isNotWeiXin ? `<div class='distance' onclick='sshowDetail(${data.id})'>${ this.$t('main["距您"]') }${ distance }</div>` : ''}
                            ${ this.isWeiXin ? `<div class='btn'>
                                <button class='detail ${this.scenic==1?'detail-scenic':''}'  style='display:${(data.ctype == 1 || data.ctype == 2 || data.ctype == 3) && data.cstatus == 2 && data.id? '':'none'}' onclick='lookDetail()'>${ this.$t('main["查看详情"]') }</button>
                                <button class='go-address ${this.scenic==1?'go-address-scenic':''}' onclick='goHere()'>${ this.$t('main["去这里"]') }</button>
                            </div>` : '' }
                        </div>
                        </div>
                        
                    </div>
                </div>`
            // 设置点
            const marker = new AMap.Marker({
                position: [data.lng, data.lat],
                map: this.map,
                offset: new AMap.Pixel(-18, -37),
                icon: new AMap.Icon({
                    image: this.curClassify.icon,
                    imageSize: new AMap.Size(36, 36),
                }),
                topWhenClick: true,
                extData: data,
                // 设置底部label
                label: {
                    offset: new AMap.Pixel(-15, 40),
                    content: data.title
                }
            })
            marker.content = content
            // 点击景点标记时显示标记上方的小框
            marker.on('click', (e) => {
                // 打开消息框
                infoWindow.setContent(e.target.content)
                infoWindow.open(this.map, e.target.getPosition())
                // 设置当前选择的点
                this.$store.commit('setCurScenicItem', data)
                // 更改播放状态
                this.playStatus = false
            })
            // 默认打开一个信息框
            marker.emit('click', {
                target: marker
            })
            // 移动地图以当前点为中心
            this.map.panTo(new AMap.LngLat(data.lng, data.lat))
            this.markers.push(marker)
            this.$store.commit('setMapMarkers', marker)
        },
        /**
         * 清空搜索词
         */
        cleanText() {
            this.keyword = ''
        },
        /**
         * 去团购券列表
         */
        gotoGroupCoupon() {
            if (this.isWeiXin) {
                window.uni.miniProgram.navigateTo({
                    url: '/packages/coupon/index/index'
                })
            } else {
                window.location.href = `${this.$baseurl}packages/coupon/index/index`
            }

        },
        /**
         * 显示线路列表
         */
        showRouteBoxFun() {
            if (this.linesArr.length == 0) {
                // 获取景区信息
                const scenicInfo = this.$store.state.scenicInfo
                const lnglatRes = _.bd_decrypt(scenicInfo.lng, scenicInfo.lat)
                // Toast('暂无推荐线路！')
                if (this.isWeiXin) {
                    // 打开地址
                    let openLocation = window.uni.openLocation
                    if (!openLocation && window.uni.miniProgram.openLocation) openLocation = window.uni.miniProgram.openLocation
                    openLocation({
                        latitude: lnglatRes.lat, // 纬度，浮点数，范围为90 ~ -90
                        longitude: lnglatRes.lng, // 经度，浮点数，范围为180 ~ -180。
                        name: scenicInfo.title, // 位置名
                        address: scenicInfo.address, // 地址详情说明
                    })
                } else {
                    if(this.isHarmonyosIdentifying) {
                        window.JsCallbackToNavi.call(`${ scenicInfo.title },${ scenicInfo.lat },${ scenicInfo.lng }`)
                        return
                    }
                    // 百度
                    // window.location.href =`http://api.map.baidu.com/marker?location=${scenicInfo.lat},${scenicInfo.lng}&title=${scenicInfo.title}&content=${scenicInfo.address}&output=html`
                    //高德
                    window.location.href = `https://uri.amap.com/marker?position=${scenicInfo.lng},${scenicInfo.lat}&name=${scenicInfo.title}`
                }
                return
            }
            // 获取地图实例
            this.map = this.$store.state.mapObj
            // 显示线路弹框
            this.showLinesList = !this.showLinesList
            if(this.showLinesList && this.isNew) {
                console.info('进入', this.showRouteDetail)
                // this.hideRouteDetail = true
                this.showRouteDetail = false
                this.showLineTypeSwitch = false
                this.closeRouteDetail()
            }
            // 当显示路线弹窗时，隐藏搜索弹窗、景点详情弹窗、POI弹窗
            if(window.hideSearchBoxFun) window.hideSearchBoxFun()
            window.hideDetailFun()
            window.hidePOIBox()
            // 点击地图关闭信息窗口
            this.map.on('click', () => {
                // 隐藏线路列表
                this.hideRouteBoxFun()
            })
        },
        /**
         * 隐藏线路列表
         */
        hideRouteBoxFun() {
            this.showLinesList = false
        },
        /**
         * 获取线路
         */
        getScenicLins() {
            if (!this.curLabel.id && this.lineLables.length) this.curLabel = this.lineLables[0] 
            if (this.userLocation.toString() == '') return
            // 转为百度坐标
            const tramRes = _.bd_encrypt(this.userLocation[0], this.userLocation[1])
            const params = {
                sid: this.sid,
                lng: tramRes.lng,
                lat: tramRes.lat,
                lid: this.curLabel.id
            }
            let scenicLinesUrl = Apis.scenicLines
            if(this.sid) scenicLinesUrl = Apis.scenicLines1
            this.axios.post(scenicLinesUrl, params).then(res => {
                // 转码操作
                if (res.data != '') {
                    res.data.map(el => {
                        el.data && el.data.map(sel => {
                            const result = _.bd_decrypt(sel.lng, sel.lat)
                            sel.lng = result.lng
                            sel.lat = result.lat
                        })
                    })
                }
                this.linesArr = res.data == '' ? [] : res.data.map(v => {
                    if(v.data && v.data.length) {
                        v.data = v.data.map(x => {
                            if(!String(x.distance).match('km')) x.distance += 'km'
                            return x
                        })
                    }
                    return v
                })
                this.curSelectedLins = res.data == '' ? '' : res.data[0]
                this.oldSelectedLins = this.curSelectedLins
                if(this.showRoute && this.isFirst && this.linesArr.length){
                    this.map = this.$store.state.mapObj
                    this.$nextTick(() => {
                        this.showLinesList = true
                    })
                }
                this.isFirst = false
            })
        },
        /**
         * 选择线路
         */
        selectLine(idx) {
            this.oldSelectedLins = this.curSelectedLins
            this.curSelectedLins = this.linesArr[idx]
            // 判断按钮显示
            if (this.curShowLine != '' && this.curSelectedLins.id == this.curShowLine.id) {
                this.showHideLineBtn = true
            } else {
                this.showHideLineBtn = false
            }
        },
        /**
         * 在地图上显示线路
         */
        showLineOnMap(idx) {
            // 选择对应下标的线路
            this.selectLine(idx)
            // 将对应下标赋值给dotid
            this.dotid=idx
            this.routePlaceSelectId=null
            // 清空地图
            _.cleanMapOverlays(this)
            // 保存显示线的数据
            this.curShowLine = this.curSelectedLins
            // 显示隐藏线路按钮
            this.showHideLineBtn = true
            // 显示线路详情弹框
            // 2024年5月29日 新版样式中 只有当不展示路线类型选择弹窗时才会显示路线详情弹窗 避免路线详情弹窗覆盖路线类型选择弹窗
            if(!this.showLineTypeSwitch) this.showRouteDetail=true
            this.hideRouteDetail=false
            // 绘制线路
            this.drawLine()
        },
        /**
         * 隐藏地图上的线路
         */
        hideLineOnMap() {
            // 清空上一次存储的marker点
            this.linesMarkers = []
            // 清空地图
            _.cleanMapOverlays(this)
            // 隐藏隐藏线路按钮
            this.showHideLineBtn = false
            // 隐藏线路详情弹框
            this.showRouteDetail=false
            this.hideRouteDetail=false
            // 修改显示线的数据
            this.curShowLine = ''
            // 显示当前分类上的点
            _.drawPoint(this)
        },
        /**
         * 绘制线路
         */
        drawLine() {
            // 经纬度数据
            const lnglatArr = []
            // 获取线路的经纬度
            this.curSelectedLins.data.map(el => {
                el.lng = el.lng
                el.lat = el.lat
                let lnglat = []
                lnglat.push(el.lng)
                lnglat.push(el.lat)
                lnglatArr.push(lnglat)
            })
            // 折线配置项，用来画黄色背景线
            const polylineOptions = {
                // strokeColor: '#ff5a00', // 线条颜色
                strokeColor: '#FF8A80', // 线条颜色
                path: lnglatArr, // 折线的节点坐标数组
                strokeStyle: 'solid', // 线样式，实线:solid，虚线:dashed
                lineJoin: 'round', // 折线拐点的绘制样式，默认值为'miter'尖角，其他可选值：'round'圆角、'bevel'斜角
                strokeWeight: 10 //线宽度
            }
            // 折线实例，用来画黄色背景线
            const polyline = this.polyline = new AMap.Polyline(polylineOptions)
            polyline.setMap(this.map)

            // 折线配置项2，用来画黄色线内的白色虚线
            const polylineOptions2 = {
                strokeColor: '#fff', // 线条颜色
                path: lnglatArr, // 折线的节点坐标数组
                strokeStyle: 'dashed', // 线样式，实线:solid，虚线:dashed
                lineJoin: 'round', // 折线拐点的绘制样式，默认值为'miter'尖角，其他可选值：'round'圆角、'bevel'斜角
            }
            // 折线实例2，用来画黄色线内的白色虚线
            const polyline2 = this.polyline2 = new AMap.Polyline(polylineOptions2)
            polyline2.setMap(this.map)

            this.map.panTo(new AMap.LngLat(lnglatArr[0].lng, lnglatArr[0].lat))
            // 信息窗口
            const opts = {
                isCustom: true,
                autoMove: true,
                // offset: new AMap.Pixel(0, -50),
                offset: new AMap.Pixel(0, -25),
            }
            const infoWindow = new AMap.InfoWindow(opts)

            // 先清空
            this.linesMarkers=[]
            // 画标注点
            lnglatArr.forEach((el, idx) => {
                // 自定义点的样式
                // <div class='text'>${idx == 0 ? '起' : (idx == lnglatArr.length - 1 ? '终' : idx)}</div>
                const content = `<div class='marker-icon-box'>
                    <div class='text'>${idx+1}</div>
                </div>`
                // 自定义信息框内容
                // <div class='audio-btn ${this.curSelectedLins.data[idx].audio != '' ? 'show': ''onclick='splayAudio(this, ${JSON.stringify(this.curSelectedLins.data[idx].audio)})'>
                //     <div class="music-wrap">
                //         <ul class="music">
                //             <li class="m1"></li>
                //             <li class="m2"></li>
                //             <li class="m3"></li>
                //             <li class="m1"></li>
                //             <li class="m2"></li>
                //             <li class="m3"></li>
                //         </ul>
                //     </div>
                // </div>
                
                let data = this.curSelectedLins.data[idx],
                distance = isNaN(Number(data.distance)) ? data.distance : (data.distance/1000) + 'km'
                const customInfoWindowContent = `<div class="custor-marker-point">
                    <div class='top-info-box'>

                        <div class='top-title'>
                            <div class='spot-name' onclick='sshowDetail(${data.id})'>${data.title}</div>
                           
                        </div>
                        <div class='bottom'>
                        <img src='${data.thumb || (!data.id && this.curClassify.icon)}' onclick='sshowDetail(${data.id})'/>
                        <div class='info-box'>
                            ${!this.isNotWeiXin ? `<div class='distance' onclick='sshowDetail(${data.id})'>${ this.$t('main["距您"]') }${distance}</div>` : ''}
                            ${ this.isWeiXin ? `<div class='btn'>
                                <button class='detail ${this.scenic==1?'detail-scenic':''}'  style='display:${(data.ctype == 1 || data.ctype == 2 || data.ctype == 3) && data.cstatus == 2 && data.id?'':'none'}' onclick='lookDetail()'>${ this.$t('main["查看详情"]') }</button>
                                <button class='go-address ${this.scenic==1?'go-address-scenic':''}' onclick='goHere()'>${ this.$t('main["去这里"]') }</button>
                            </div>` : '' }
                        </div>
                        </div>
                        
                    </div>
                </div>`
                // 构造一个点标记对象
                const marker = new AMap.Marker({
                    position: el,
                    content: content,
                    // offset: new AMap.Pixel(-18, -36),
                    offset: new AMap.Pixel(-8,-12),
                })
                marker.customInfoWindowContent = customInfoWindowContent
                marker.setMap(this.map)
                // 点击景点标记时显示标记上方的小框
                marker.on('click', (e) => {
                    // 点击线路上的点，线路详情里的序号也选择，背景颜色变绿色
                    this.routePlaceSelectId=idx
                    // 打开消息框
                    infoWindow.setContent(e.target.customInfoWindowContent)
                    infoWindow.open(this.map, e.target.getPosition())
                    // 设置当前选择的点
                    this.$store.commit('setCurScenicItem', this.curSelectedLins.data[idx])
                    // 更改播放状态
                    this.playStatus = false
                })
                // 存储线路上的marker点以便后面使用
                this.linesMarkers.push(marker)
                // 全局存储marker点以便后面删除操作
                this.$store.commit('setMapMarkers', marker)
            })
            // 点击地图关闭信息窗口
            this.map.on('click', () => {
                infoWindow.close()
            })
            // 隐藏线路列表
            this.hideRouteBoxFun()
        },
        /**
         * 线路上显示信息窗口的判断
         */
        showInfoWindow(itemIdx, lineId) {
            console.log('1itemidx:',itemIdx)
            // console.log('lineId:',lineId)
            // console.log('linesMarkers:',this.linesMarkers)
            
            this.routePlaceSelectId=itemIdx
            // 判断当前点击的点的线路是否已经显示，已显示的只做展开点信息和把当前点击的点移动到地图中间显示，未显示则显示线路在地图上并且展示当前点击的点的信息和移动这个点到地图中间
            // if (this.curShowLine != '' && this.oldSelectedLins.id == lineId) {
                // 打开一个信息框
                this.linesMarkers[itemIdx].emit('click', {
                    target: this.linesMarkers[itemIdx]
                })
                this.map.panTo(this.linesMarkers[itemIdx].getPosition())
                // 隐藏线路列表
                this.hideRouteBoxFun()
            // } else {
            //     // 清空上一次存储的marker点
            //     this.linesMarkers = []
            //     // 设置旧的线路数据为新的线路数据
            //     this.oldSelectedLins = this.curSelectedLins
            //     // 显示线路
            //     this.showLineOnMap()
            //     // 打开一个信息框
            //     this.linesMarkers[itemIdx].emit('click', {
            //         target: this.linesMarkers[itemIdx]
            //     })
            //     this.map.panTo(this.linesMarkers[itemIdx].getPosition())
            // }

        },
        /**
         * 输入框失焦后，页面归位
         */
        pageReset() {
            console.log('输入框失焦')
            window.scroll(0, 0)
        },
        touchStart(e){
            // console.log('start:',e);
            let x=e.changedTouches[0].clientX
            this.touchX=x
        },
        touchEnd(e){
            // console.log('end:',e);
            let x=e.changedTouches[0].clientX
            if(x-this.touchX>50){
                if(this.dotid>0){
                    // this.dotid-=1;
                    this.showLineOnMap(this.dotid-1)
                    this.routePlaceSelectId=null
                    // console.log(this.curSelectedLins)
                }
               
            }else if(this.touchX-x >50){
                if(this.dotid<this.linesArr.length-1){
                    // this.dotid+=1;
                     this.showLineOnMap(this.dotid+1)
                     this.routePlaceSelectId=null
                    //  console.log(this.curSelectedLins)
                }
                
            }
        },
        /**
         * 查看详情
         */
        lookDetail(){
            if(!this.curScenicItem.id) return // 高德查询出来的点位不给进入详情页
           
            if(this.isWeiXin){
                // 景点详情
                if(this.curScenicItem.ctype == 1){
                    // scenic = 1 为景区通路径
                    var url = this.scenic == 1 ? `/pages/scenic/detail/index?category=${this.curScenicItem.category}${ this.sid ? '&isScenic=1' : '' }&id=` : '/packages/city_service/scenic/detail/index?id='
                    // var url = this.scenic == 1 ? '/pages/scenic/info/index?id=' : '/packages/city_service/scenic/detail/index?id='
                    window.uni.miniProgram.navigateTo({
                        url: url + `${this.curScenicItem.id}`
                    })
                }
                // 美食详情
                if(this.curScenicItem.ctype == 2 || this.curScenicItem.ctype == 3){
                    var url = this.scenic == 1 ? '/packages/food/detail/index?id=' : '/packages/city_service/scenic/detail/index?id='
                    window.uni.miniProgram.navigateTo({
                        url: url + `${this.curScenicItem.id}&type=${this.curScenicItem.ctype == 2 ? 2 : 1}`
                    })
                }
            }else{
              
                // 景点详情
                if(this.curScenicItem.ctype == 1){
                    var url = this.scenic == 1 ? `${this.$scenicUrl}pages/scenic/detail/index?id=${this.curScenicItem.id}` : `${this.$baseurl}packages/city_service/scenic/detail/index?id=${this.curScenicItem.id}`
                    // var url = this.scenic == 1 ? `${this.$scenicUrl}pages/scenic/info/index?id=${this.curScenicItem.id}` : `${this.$baseurl}packages/city_service/scenic/detail/index?id=${this.curScenicItem.id}`
                    window.location.href = url
                }
                // 美食详情
                if(this.curScenicItem.ctype == 2 || this.curScenicItem.ctype == 3){
                    var url = this.scenic == 1 ? `${this.$scenicUrl}packages/food/detail/index?id=${this.curScenicItem.id}` : `${this.$baseurl}packages/city_service/scenic/detail/index?id=${this.curScenicItem.id}&type=${this.curScenicItem.ctype == 2 ? 2 : 1}`
                    window.location.href = url
                }
            }
            
        },
        /**
         * 导航
         */
        goHere(item){
            let curScenicItem = item || this.curScenicItem
            if(this.isWeiXin){
                // 打开地址
                let openLocation = window.uni.openLocation
                if (!openLocation && window.uni.miniProgram.openLocation) openLocation = window.uni.miniProgram.openLocation
                openLocation({
                    latitude: curScenicItem['lat'], // 纬度，浮点数，范围为90 ~ -90
                    longitude: curScenicItem['lng'], // 经度，浮点数，范围为180 ~ -180。
                    name: curScenicItem['title'], // 位置名
                    address: curScenicItem['address'] // 地址详情说明
                })
            } else {
                if(this.isHarmonyosIdentifying) {
                    window.JsCallbackToNavi.call(`${ curScenicItem.title },${ curScenicItem.lat },${ curScenicItem.lng }`)
                    return
                }
                this.$emit('showQrcode')
                // 百度
                // window.location.href =`http://api.map.baidu.com/marker?location=${curScenicItem.lat},${curScenicItem.lng}&title=${curScenicItem.title}&content=${curScenicItem.address}&output=html`
                //高德
                // window.location.href = `https://uri.amap.com/marker?position=${curScenicItem.lng},${curScenicItem.lat}&name=${curScenicItem.title}`
            }
            
        },
        closeRouteDetail(){
            this.hideLineOnMap()
            this.showRouteDetail=false
            this.hideRouteDetail=false
        },
        divTouchMove(e){
            e.preventDefault()
        },
        // 经纬度转换成三角函数中度分表形式。
        rad(d) {
            return d * Math.PI / 180.0 
        },
        /**
         * 根据经纬度计算距离，参数分别为第一点的纬度，经度；第二点的纬度，经度 
         * 返回单位为米
         */
        getDistance(lat1, lng1, lat2, lng2) {

            var radLat1 = this.rad(lat1)
            var radLat2 = this.rad(lat2)
            var a = radLat1 - radLat2
            var b = this.rad(lng1) - this.rad(lng2)
            var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
                Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)))
            s = s * 6378.137 // EARTH_RADIUS;
            s = Math.round(s * 10000) / 10000 //输出为公里

            return s * 1000
        },
        /**
         * 根据传入经纬度获取临近的景点
         */
        getNearScenicSpot(lat, lng){
            // 2022/2/24 由于需要等待接口返回数据 通过Promise改为同步方法
            return new Promise((resolve, reject)=>{
                // 获取所有景点
                let list = JSON.parse(JSON.stringify(this.curScenicList || '[]'))

                // 根据定位获取最近景点
                if(lat !== -1 && lng !== -1) {
                    // 获取对应距离
                    list.forEach(v => {
                        v.distanceNum = this.getDistance(v.lat, v.lng, lat, lng)
                    })
                    // 按距离从小到大排序
                    list.sort((x,y) => x.distanceNum - y.distanceNum)

                    // 获取最近且距离不超过20米的景点并返回
                    // 2022/1/13 改为50米
                    // 2022/2/15 改为30米
                    if(list.length && list[0].distanceNum < 30) resolve(list[0])
                    else resolve()
                } else { // 根据蓝牙获取最近景点
                    // 获取通过小程序搜索附近蓝牙并储存起来的数据
                    this.axios.post(Apis.getCache, {key: this.cacheKey,time: new Date().getTime()}).then(res => {
                        /**
                         * 异常结果示例： 
                         * "{\"errMsg\":\"startBeaconDiscovery:fail 开发者工具暂时不支持此 API 调试，请使用真机进行开发\"}"
                         * "{\"errCode\":\"11001\", \"errMsg\":\"startBeaconDiscovery:fail bluetooth service unavailable\"}"
                         */
                        let resObj = typeof res.data == 'string' ? JSON.parse(res.data) : res.data
                        if(resObj.errCode == 11001) resolve(this.$t('main["请开启蓝牙服务以便使用边走边听"]'))
                        else if (resObj.errCode == 11002) resolve(this.$t('main["请开启位置服务以便使用边走边听"]'))
                        else if (resObj.errCode == 11000) resolve(this.$t('main["系统或设备不支持蓝牙定位"]'))
                        else if (resObj.errCode == 11005) resolve(this.$t('main["系统错误"]'))
                        else if (resObj.errMsg) resolve(resObj.errMsg)
                        else {
                            /**
                             *  正常结果示例：
                             * '[{\"uuid\":\"fda50693-a4e2-4fb1-afcf-c6eb07647825\",\"major\":54984,\"minor\":35959,\"proximity\":0,\"accuracy\":0.6039230219518864,\"rssi\":-58},
                             *   {\"uuid\":\"fda50693-a4e2-4fb1-afcf-c6eb07647825\",\"major\":54984,\"minor\":35958,\"proximity\":0,\"accuracy\":6.8427936089076375,\"rssi\":-74},
                             *   {\"uuid\":\"fda50693-a4e2-4fb1-afcf-c6eb07647825\",\"major\":54984,\"minor\":35957,\"proximity\":0,\"accuracy\":0.35508190798262945,\"rssi\":-55}]
                             */


                            let arr = []
                            // 获取符合条件 uuid、major、minor相同且在蓝牙距离在景点设置的范围内的景点
                            resObj.forEach(v => {
                                // 小程序获取蓝牙数据时 IOS的uuid为大写 安卓的uuid为小写！！！调用toLowerCase()转小写
                                let obj = list.find(x => x.bluetooth_uuid == v.uuid.toLowerCase() && x.bluetooth_major == v.major && x.bluetooth_minor == v.minor && x.bluetooth_distance > v.accuracy)
                                if(obj) arr.push({ ...obj, accuracy: v.accuracy })
                            })

                            // 按蓝牙距离从小到大进行排序 筛选出最近的景点
                            arr.sort((x,y) => {
                                return x.accuracy - y.accuracy
                            })
                            resolve(arr[0])
                        }
                    })
                }
            })
        },
        /**
         * 根据传入的经纬度信息展示最近的景点信息并播放景点录音
         */
        async playNearScenicSpot(lat, lng){
            // 获取20米内最近的景点 等待异步方法执行完成返回结果再继续hi行
            let spot = await this.getNearScenicSpot(lat, lng)
            this.storedAudio = ''

            // 返回错误信息 展示并停止后续操作
            if(spot && typeof spot == 'string') {
                Toast(spot)
                return
            }
            // 没有获取到最近的景点或者获取到的景点已经展示过了
            if(!spot || spot.id === this.lastNearScenicSpotId) return

            // 没有语音
            if(!spot.audio.length) return

            // 当前有其他景点信息在展示
            // 2022/2/28 取消有显示景点信息时不播放音频的限制
            // if(this.showDetailPop) return

            let playEl = document.getElementsByClassName('go-detail')[0]
            // 当前有音频正在播放
            // 2022/3/10 增加新逻辑 详情看playComplete方法注释
            if(playEl && playEl.classList.contains('isPlay')) {
                this.storedAudio = spot
                return
            }

            // 防止在范围内时多次显示同一个景点
            this.lastNearScenicSpotId = spot.id

            // window.showDetail(el.id)
                     
            // infoWindow.setContent(e.target.content)
            // infoWindow.open(vueObj.map, e.target.getPosition())
            // 设置当前选择的点
            this.$store.commit('setCurScenicItem', spot)
            this.$store.commit('setDetailPopupStatus', true)
            // 更改播放状态
            // this.playStatus = false

            // 2022/2/21增加计时器 防止DOM元素渲染不及时导致获取到的DOM元素为空
            setTimeout(() => {
                // 当第一次没获取到按钮时需要重新获取按钮dom
                if(!playEl) playEl = document.getElementsByClassName('go-detail')[0]
                // 开始播放
                playEl.click()
            }, 100)
        },
        /**
         * 关闭获取附近蓝牙数据
         */
        closeGetBluetooth(){
            clearInterval(this.intervalKey)
            this.intervalKey = ''
            this.isBluetooth = false
            // 清除储存的最近景点数据
            this.storedAudio = ''
        },
        /**
         * 音频播放完成后触发
         * 2022/3/10 增加此逻辑 由于反馈边走边听功能开启后音频自动播放完成后顺序播放其他音频不灵敏 在音频播放的过程中收集最近的一个音频并保存 且该音频与当前播放的音频不为同一个 在自动播放音频结束后播放收集到的最近音频
         */
        playComplete () {
            // 当不为蓝牙定位的边走边听 或没有储存最近音频时停止后续操作
            if(!this.isBluetooth || (this.isBluetooth && !this.storedAudio)) return

            // 防止在范围内时多次显示同一个景点
            this.lastNearScenicSpotId = this.storedAudio.id

            // 赋值
            this.$store.commit('setCurScenicItem', this.storedAudio)
            this.$store.commit('setDetailPopupStatus', true)

            // 播放
            document.getElementsByClassName('go-detail')[0].click()
            // 清除储存的最近景点数据
            this.storedAudio = ''
        },
        // 切换选中的路线标签
        checkedLabel(item) {
            this.curLabel = item
            this.getScenicLins()
        },

        onmousedown(e){
            if(!this.curSelectedLins.line_introduce) return
            //记录手指放上去的时间
			this.explainData.startTime = e.timeStamp
			//记录滑块的初始位置
			// this.start_slide_x = this.listData[index].slide_x
			// 记录上一次开始时手指所处位置
			// this.startX = e.touches[0].pageX
            this.explainData.startY = e.pageY || e.changedTouches[0].pageY
			// 记录上一次手指位置
			this.explainData.lastY = this.explainData.startY
        },
        onmousemove(e){
            // if(!this.curSelectedLins.line_introduce) return
            // const endX = e.touches[0].pageX
			// const distance = endX - this.lastX;
			// // 预测滑块所处位置
			// const duang = this.listData[index].slide_x + distance;
			// // 如果在可行区域内
			// if (duang <= 0 && duang >= this.btnWidth) {
			// 	// this.listData[index].slide_x = duang;
			// 	this.$set(this.listData[index], 'slide_x', duang)
			// }
			// // 此处手指所处位置将成为下次手指移动时的上一次位置
			// this.lastX = endX
        },
        onmouseup(e){
            if(!this.curSelectedLins.line_introduce) return
            // 没有经过onmousedown
            if(this.explainData.startY == 0) return
            this.explainData.lastY = e.pageY || e.changedTouches[0].pageY
            let distance = 100
			// const endTime = e.timeStamp
			const y_end_distance = this.explainData.startY - this.explainData.lastY
			// if (Math.abs(endTime - this.explainData.startTime) > 200) {
			// 	distance = this.btnWidth / -2
			// }
			// 判断手指最终位置与手指开始位置的位置差距
			if (y_end_distance > distance) {
				// this.listData[index].slide_x = this.btnWidth;
                this.showExplain = true
			} else if (y_end_distance < distance * -1) {
				// this.listData[index].slide_x = 0;
                this.showExplain = false
			} else {
                // 不超过限制的distance
				// this.listData[index].slide_x = this.start_slide_x;
                // this.showExplain = false
			}
            this.explainData.startY = 0
        },
        showSpotFun() {
            this.showLinesList = false
            this.showRouteDetail = false
            window.showSpotFun()
        }
    }
}
</script>

<style lang="scss" scoped>
.search-content-box {
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: .55rem;
    height: 1.1rem;
    padding: 0 .3rem;
    justify-content: space-around;
    .btn {
        width: 1rem;
        height: 1rem;
        padding-top: .6rem;
        color: #333;
        font-size: .22rem;
        margin: 0 .3rem;

        width: 1.4rem;
        margin: 0 .1rem;
    }

    .search-btn {
        background: #fff url('../../assets/left_btn_walk.png') no-repeat center .1rem/.36rem .36rem;
    }
    .search-scenic {
        background: #fff url('../../assets/walking-sc.png') no-repeat center .1rem/.36rem .36rem;
    }
    .coupon-btn {
        background: #fff url('../../assets/left_btn_position.png') no-repeat center .1rem/.36rem .36rem;
    }
    .coupon-scenic {
        background: #fff url('../../assets/position-sc.png') no-repeat center .1rem/.36rem .36rem;
    }

    .route-btn {
        width: 1.3rem;
        height: 1.3rem;
        border-radius: 50%;
        box-shadow: 0 .06rem .07rem rgba($color: #000, $alpha: .2);
        color: #fff;
        margin: 0 .1rem;
        margin-bottom: 0.5rem;
        padding-top: .75rem;
        background: #48c1ff url(../../assets/routr_icon.png) no-repeat 50% 25% / .6rem .6rem;
    }
    .route-scenic{
        background: #009D7A url(../../assets/routr_icon.png) no-repeat 50% 25% / .6rem .6rem;
    }

}

.search-list-box {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    font-size: .3rem;
    transform: translateY(200%);
    transition: all .3s;

    &.show {
        transform: translateY(0);
    }
    &.search-list-box-scenic {
        .list-box ul li .subtitle .detail-btn .text {
            color: #399D79;
        }
    }

    .top-search-input {
        position: relative;
        padding: .2rem 1.1rem .2rem .2rem;
        border-bottom: 1px solid #eee;

        form {
            position: relative;

            .clean-text {
                position: absolute;
                top: .05rem;
                right: .05rem;
                width: .4rem;
                height: .4rem;
                background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFDUlEQVRoQ+1ZTWwbRRR+b13AJi2KFESBSBARQEiUC5deOFB6AAoolKJcKaJNJFIiaOwZJ1DF9BA8u05SuUQVLYgfcUEFWkAp6gXKDXHgAkhACWqQKCBapIr8mFjeD43ktdaO451d260idU5x5r3vve+9N7NvZpjW+eB17j9dJVCbwcnJybtLpdJ2AJv1HDNfAjAfi8XmV1ZWzo2NjV1sZdabzoBS6lZm3kFE24joISK6uZGDAP5g5i+J6GRPT8/H/f39pWYIRSZg2/ZdRKSIaGcTDvxJRG8COCKlPB8FJzSBmZmZjQsLC68w834iuiaK0VodACvMfGhpaenVTCazFAYzFIFsNnuvZVmfEFFvGCMhZOdc1+1Lp9M/mOoYE8hmsw9blvUREXWYgkeUW3Rdd1c6nT5tom9EQCn1HBEdZWbLBLRZGQAuEQ1IKd8KwgokYNv2IwBmL5fznsOaBDM/IYQ41YhEQwK5XO4e13W/JaJEUCTaNL9sWdb9yWTyx7Xw1ySQz+evW15e/p6Z72yTc0awAH5JJBJbhoeH/6unsCYBpVSGmceNrLRfaFwIcdCYQC6Xu9F13d+uYOnU+qpL6bZkMnmhdqJuBpRS08z8okFgfwcwzswPENFuA3m/yHEiOgXgADPfEaQLYEpKORJIoFz7/zDz9UGgRPSMEOI9LWfbdpqIXjPQ0SI5IURK/+E4Th+Ak0F6AP7t7OzsGhwcLPplV2XAtm0dybeDAPU8gNellC94soYkKs5rPaXUBDOPGtrrk1J+GkTgQyLaZQJYJvGSlPKQJx+w+Kucz2azey3LOhrC1jEp5UBDAkqpC8zcZQpaj4Rt27qUdEn5x0EhRGVXC+t8GWhOCFG1rVeV0PT09C3FYjFSW0tEzwshjvjKyU8iJYTI+bK0j5kPhwmSJ9vR0bFpaGhowftdRcBxnAcB6MNG1FGPxMVWOV/O9lYp5Td1CSilnmZmvb01M6pI+IGUUpEj7+EA2CmlrOxaVRkIswMFMFxFwrbtpN41m4lMWbeydevfbSHguu5AOp0+1urol0tot5Ty3XaVEFzXHax1vhWL1xeMfiFEpcxrF/FWAF9HTDN0O+F9mTWGbdu6ZP5q5SJm5m2pVOpM3Qzk8/kbCoXCpQgEVjmvlDrMzPvKWC3bRgF0+28wVrUSSqmzIc8AQc578agiEeVDBuBvKeVN/gDX64X04ttjmAVT5z24Zr/Gx4UQ/Q0JmHaHZZAJIcTLvkXqL5u1YhC5mSOiZ4UQ7zQkkMlkrk0kErof2hSUBQCV7rCm5oNUKySUUk8y84kgBSJaZObNqVRqsSGB8u6h+5ZVh4daIwB+Zeb3AWxh5qcMnPCLfADgcyLSR9ceA92qzNXdhbx/6iNlqVSaNzzUGNhuWiTckVKbcxxnHECmadOtAQh3qNc29dGyUCh8R0T6FvpKjrPxePy+0Ncq2uN1fbHlhdy27R0APluXV4s+EnsAvHG5SLT0ctcjkc1mH7UsS3eB6+963UdCP3DMEtHtbVrVcwAek1L+ZIofeL1eC+Q4Tofrugf0h46ZN5gaCpDTl1XTbX9i8jsxNTXVXSwWB5l5b9DLZIDzJ0ql0v7R0dFzUYIROgO1RjKZzIZ4PK4vAx5n5u1BZPQzKxF9AeArZp6N+jrZsJWIEglPZ2JioisWi/ValtUNoBfARj3HzOdjsdiZkZGRn5vBr9VtOgOtdCYK1lUCUaLWSp3/AZXFSU+MrR38AAAAAElFTkSuQmCC) no-repeat center center / .4rem;
            }
        }

        input {
            font-size: .26rem;
            width: 100%;
            display: block;
            border-radius: .1rem;
            outline: none;
            border: 0;
            height: .5rem;
            line-height: .5rem;
            padding-left: .5rem;
            background: #eee;
            -webkit-appearance:none;
            &::-webkit-search-cancel-button {
                display: none;
            }
            // background: #eee url(../../assets/search_icon_1.png) no-repeat .1rem center / .4rem;
        }
        .input-icon {
            position: absolute;
            left: 0.05rem;
            top: 0.05rem;
            width: 0.4rem;
            height: 0.4rem;
        }

        .close-btn {
            position: absolute;
            top: .2rem;
            right: .2rem;
            width: .8rem;
            height: .5rem;
            text-align: center;

            &::after {
                content: '';
                display: inline-block;
                width: .2rem;
                height: .2rem;
                border-right: 1px solid #333;
                border-bottom: 1px solid #333;
                transform: rotate(45deg);
            }
        }
    }

    .list-box {
        padding: 0 .2rem;
        height: 5.7rem;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;

        ul li {
            list-style: none;
            padding: .2rem 0;
            border-bottom: 1px solid #eee;
            text-align: left;

            &.point-list {
                border-bottom: 0;
                text-align: center;
                font-size: .24rem;
                color: #adadad;
            }

            .title {
                position: relative;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                padding-right: 1.5rem;

                .jl-num {
                    position: absolute;
                    top: 0;
                    right: 0;
                    font-size: .22rem;
                    color: #adadad;
                }

                &.group-coupon::after {
                    content: '团';
                    display: inline-block;
                    padding: 0 .04rem;
                    margin-left: .05rem;
                    background: #f6b420;
                    color: #fff;
                    font-size: .22rem;
                }
            }

            .subtitle {
                position: relative;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                // padding-right: 1.5rem;
                color: #adadad;
                font-size: .26rem;
                display: flex;
                
                &-content {
                    flex: 1;
                }
                .detail-btn {
                    // position: absolute;
                    // top: 0;
                    // right: 0;
                    font-size: .26rem;
                    color: #48c1ff;
                    padding-right: .1rem;

                    .text {
                        display: inline-block;
                        vertical-align: middle;
                    }

                    &::after {
                        content: '';
                        display: inline-block;
                        width: .1rem;
                        height: .1rem;
                        border-top: 1px solid #48c1ff;
                        border-right: 1px solid #48c1ff;
                        transform: rotate(45deg);
                        vertical-align: middle;
                    }
                }
            }
        }
    }
}

// .route-box {
//     position: fixed;
//     bottom: 0;
//     left: 0;
//     right: 0;
//     background: #fff;
//     font-size: .3rem;
//     transform: translateY(200%);
//     transition: all .3s;
//     z-index: 1000;

//     &.show {
//         transform: translateY(0);
//     }

//     .top-tab-box {
//         display: flex;
//         align-items: stretch;
//         overflow: hidden;

//         ul {
//             flex: 1 0 0%;
//             overflow-x: auto;
//             -webkit-overflow-scrolling: touch;
//             white-space: nowrap;
//             text-align: left;
//             background: #eee;

//             li {
//                 list-style: none;
//                 position: relative;
//                 display: inline-block;
//                 padding: 0 .2rem;
//                 font-size: .28rem;
//                 color: #333;
//                 height: .8rem;
//                 line-height: .8rem;
//                 border-bottom: 0;

//                 &.on {
//                     background: #fff;
//                     color: #ff5a00;
//                 }

//                 .corner-mark {
//                     position: absolute;
//                     top: .05rem;
//                     right: .05rem;
//                     line-height: normal;
//                     border-top-left-radius: .1rem;
//                     border-top-right-radius: .1rem;
//                     border-bottom-right-radius: .1rem;
//                     background: #ff5a00;
//                     color: #fff;
//                     font-size: .12rem;
//                     padding: 0 .05rem;
//                 }
//             }
//         }

//         .close-btn {
//             position: relative;
//             width: .8rem;
//             text-align: center;
//             border-left: 1px solid #ccc;

//             &::after {
//                 position: absolute;
//                 top: 50%;
//                 left: 50%;
//                 content: '';
//                 display: inline-block;
//                 width: .2rem;
//                 height: .2rem;
//                 border-right: 1px solid #333;
//                 border-bottom: 1px solid #333;
//                 transform: rotate(45deg) translate(-100%, -20%);
//             }
//         }
//     }

//     .content-box {
//         padding: 0 .4rem;

//         .point-text {
//             font-size: .22rem;
//             color: #999;
//             padding: .2rem 0;
//             text-align: left;
//         }

//         &>ul {
//             font-size: .28rem;
//             height: 4rem;
//             -webkit-overflow-scrolling: touch;
//             overflow-y: auto;

//             li {
//                 display: flex;
//                 align-items: center;
//                 padding: .2rem 0;
//                 border-bottom: 1px solid #eee;

//                 .title {
//                     flex: 1 0 0%;
//                     text-align: left;
//                 }

//                 .time-box {
//                     display: flex;
//                     align-items: center;

//                     .time {
//                         display: inline-block;
//                     }

//                     .icon {
//                         width: .4rem;
//                         height: .4rem;
//                         display: inline-block;
//                         margin-right: .1rem;
//                     }

//                     .walk-icon {
//                         background: url(../../assets/walk_icon.png) no-repeat center center / .4rem;
//                     }

//                     .riding-icon {
//                         background: url(../../assets/riding_icon.png) no-repeat center center / .4rem;
//                     }

//                     .ferry-icon {
//                         background: url(../../assets/ferry_icon.png) no-repeat center center / .4rem;
//                     }

//                     .drive-icon {
//                         background: url(../../assets/drive_icon.png) no-repeat center center / .4rem;
//                     }
//                 }

//                 .list-btn-box {
//                     width: 1.3rem;
//                     text-align: center;
//                     display: flex;
//                     justify-content: center;

//                     .audio-btn {
//                         width: .48rem;
//                         height: .48rem;
//                         border-radius: 50%;
//                         display: inline-block;
//                         background: #48c1ff url(../../assets/audio_icon.png) no-repeat center center / .28rem;
//                     }
//                 }
//             }
//         }

//         .btn-box {
//             text-align: center;
//             font-size: .28rem;
//             padding: .2rem 0;

//             .show-route {
//                 display: inline-block;
//                 color: #fd9826;
//                 padding: .15rem .45rem;
//                 border: 1px solid #fd9826;
//                 border-radius: .1rem;
//             }
//         }
//     }
// }
.route-box {
    position: fixed;
    bottom: 1rem;
    left: 0;
    right: 0;
    background: #fff;
    font-size: .3rem;
    transform: translateY(200%);
    transition: all .3s;
    z-index: 1000;
    padding: 0 .3rem;
    max-height: 8rem;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    &.navHide {
        bottom: 0;
    }

    &.show {
        transform: translateY(0);
    }

    .item {
        border-bottom: .02rem solid #E4E4E4;
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 1.62rem;

        .left {
            min-height: 1.62rem;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: flex-start;
            padding: .3rem 0;

            .title {
                font-size: .32rem;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
                text-align: left;

            &.selected{
                color: #48c1ff;
            }

                span {
                    position: relative;
                    top: -.25rem;
                    right: -.05rem;
                    border-top-left-radius: .1rem;
                    border-top-right-radius: .1rem;
                    border-bottom-right-radius: .1rem;
                    background: #ff5a00;
                    color: #fff;
                    font-size: .18rem;
                    padding: .05rem .1rem;
                }
            }

            .detail {
                font-size: .24rem;
                color: rgba(102, 102, 102, 1);

                span {
                    display: inline-block;
                    height: .42rem;
                    line-height: .42rem;
                    padding: 0 .15rem;
                    border: .02rem solid rgba(204, 204, 204, 1);
                    border-radius: 21px;
                    margin-right: .2rem;
                }
            }
        }

        button {
            height: .55rem;
            line-height: .55rem;
            border: .02rem solid #48c1ff;
            border-radius: .28rem;
            font-size: .28rem;
            color: #333;
            padding: 0 .3rem;
            background-color: #fff;
            flex-shrink: 0;
        }
        .btn-scenic{
            border: .02rem solid #009D7A;
        }

        button::after {
            border-radius: .28rem;
        }

    }

    .route-labels {
        display: flex;
        align-items: center;
        font-size: .26rem;
        font-weight: 400;
        color: #999999;
        padding-top: .30rem;
        overflow-y: hidden;
        overflow-x: auto;
        position: sticky;
        top: 0;
        background: white;
        z-index: 10;

        .route-label {
            margin-right: .7rem;
            white-space: nowrap;
            height: 0.54rem;
            line-height: .56rem;
            &.checked {
                font-size: .34rem;
                font-weight: bold;
                color: #399D79;
                position: relative;
                line-height: .54rem;
                &::after {
                    content: '';
                    display: inline-block;
                    width: .65rem;
                    height: .06rem;
                    background: #399D79;
                    border-radius: .3rem;
                    position: absolute;
                    left: 50%;
                    // bottom: -0.1rem;
                    bottom: 0;
                    transform: translate(-50%, 0);
                }
            }
        }
    }
}
.bottomHeight{
    bottom: 1.4rem;
}

.route-box::-webkit-scrollbar {
    display: none;
}

.mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #000;
    opacity: 0;
    z-index: -1;
    display: none;
    transition: opacity .3s;
}

.mask.show {
    display: block;
    opacity: .5;
    z-index: 500;
    transition: opacity .3s;
}

.route-detail-box {
    position: fixed;
    bottom: 0;
    // bottom: 1rem;
    left: 0;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    background-color: #fff;
    padding: .3rem;
    padding-bottom: 0;
    transform: translateY(1000%);
    transition: transform .3s;
    z-index: 1;
    // border-bottom: 1px solid #e4e4e4;
    .showBox{
        position: absolute;
        left: .1rem;
        top: 0;
        width: .5rem;
        height: 1rem;
        background: url('../../assets/showBox_left_icon.png') no-repeat center center/100%;
    }

    .hideBox{
       position: absolute;
        right: .8rem;
        top:.1rem;
        width: .5rem;
        height: .5rem;
        background: url('../../assets/showBox_right_icon.png') no-repeat center center/.4rem .4rem;
    }

    .close-btn {
        position: absolute;
        right: .2rem;
        top:.1rem;
        width: .5rem;
        height: .5rem;
        background: url('../../assets/classify_close_icon.png') no-repeat center center/.3rem .3rem;
    }

    .dot-box {
        width: 100%;
        background-color: #fff;
        display: flex;
        justify-content: center;

        .dot {
            width: .12rem;
            height: .12rem;
            border-radius: 50%;
            transition: width .3s;
            border: none;
            background-color: #CCCCCC;
            margin: 0 .1rem;

            &.active {
                border: none;
                width: .3rem;
                height: .12rem;
                border-radius: 35%;
                transition: width .3s;
                background-color: #48c1ff;
            }
            &.active-scenic{
                background-color: #009D7A;
            }
        }

    }

    .item {
        padding-bottom: 1.1rem;
    }

    .top {
        border-bottom: .02rem solid rgba(228, 228, 228, 1);
        padding: .3rem 0;

        .title {
            font-size: .32rem;
            color: #333333;
            font-weight: bold;
            text-align: left;
        }

        .subtitle {
            font-size: .24rem;
            color: #666;
            margin-top: .2rem;
            text-align: left;
        }
    }

    .bottom {
        // padding: .6rem 0 1.1rem;
        padding: .6rem 0 0;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        background-color: #fff;
        display: flex;
        flex-wrap: nowrap;

        .box {
            display: flex;
            // align-items: center;

            .content {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;

                .index {
                    width: .6rem;
                    height: .6rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: .02rem solid #48c1ff;
                    border-radius: 50%;
                    font-size: .36rem;
                    color: #48c1ff;

                    &.active {
                        background-color: #48c1ff;
                        color: #fff;
                    }
                }
                .index-scenic{
                    border: .02rem solid #009D7A;
                    color: #009D7A;
                    &.active-sc {
                        background-color: #009D7A;
                        color: #fff;
                    }
                }

                .title {
                    width: 1.2rem;
                    font-size: .24rem;
                    color: #333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-top: .2rem;
                }
            }

            .arrow {
                width: 1.2rem;
                height: .5rem;
                background:url('../../assets/route-detail-arrow.png') no-repeat center center /100%;
                margin-top: .05rem;
                position: relative;
                span {
                    font-size: 0.24rem;
                    color: #666666;
                    position: absolute;
                    left: 50%;
                }
                .nxmode-text {
                    transform: translate(-50%, -0.20rem);
                }
                .nxmode-nxdistance {
                    transform: translate(-50%, 0.36rem);
                }
            }
            .arrow-scenic{
                background:url('../../assets/arrow-scenic.png') no-repeat center center /100%;
            }
        }

    }

    .bottom::-webkit-scrollbar {
        display: none;
    }

    .explain {
        .explain-top {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: .2rem;
            .icon {
                height: .2rem;
                width: .2rem;
                margin-bottom: .1rem;
                background: url(../../assets/arrow_top.png) center center / 100% 100% no-repeat;
                &.icon1 {
                    background-image: url(../../assets/arrow_top_wap.png);
                }
            }
            .txt {
                font-size: .24rem;
                font-weight: 500;
                color: #666666;
            }
        }
        .explain-bottom {
            margin-top: .3rem;
            padding-top: .3rem;
            border-top: .02rem solid #E9E9E9;
            .explain-content {
                display: inline-block;
                max-height: 2.54rem;
                overflow-y: auto;
                text-align: left;
                font-size: initial;
                font-weight: initial;
            }
        }
    }
}

.route-detail-box.active{
    transform: translateY(0);
    transition: transform .3s;
}

.route-detail-box.hide{
    transform: translateX(92%);
    height: 1rem;
    bottom: 1.1rem;
    transition: all .3s;
    border-radius: .2rem;
}
.route-detail-box.isIphoneX{
    // .bottom{
    //     padding-bottom: 1.5rem;
    // }
    .item {
        padding-bottom: 1.5rem;
    }
}

.bottm-btn-box.isH5{
    bottom: 1.5rem;
    padding-bottom: 0;
    width: 0.6rem;
    .search-content-box {
        background: rgba(255,255,255,0);
        .coupon-btn, .search-btn {
            display: none;
        }
        .route-btn {
            min-width: 1.3rem;
        }
    }
}
</style>
